/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import { cloneDeep, isEmpty, isEqual, omitBy } from 'lodash';
import { transformProducts, parsedInteger } from '../../../builder/components/modals/inventory/inventory.util';
import { fplsFetch } from '../../../../shared/utils';

const { toFrontEndShape } = transformProducts;

export const getAllCtagories = async (products, inForm) => {
  const url = inForm ? `/api/v2/public/inventory_category` : `/api/v2/user/inventory_category`;
  const categoryIds = products.flatMap((product) => product.category);
  const uniqueCategoryIds = [...new Set(categoryIds)];
  if (!categoryIds.length) return [];
  let categories = [];

  try {
    const response = await fplsFetch({ url });
    categories = response.categories;
  } catch (err) {
    console.log(err);
  }

  categories = categories.filter((category) => uniqueCategoryIds.includes(category.id));
  categories.unshift({
    category_name: 'All',
    id: 'all',
  });

  return categories;
};

export const getAvailableOptions = (product) => {
  const newAvailableOptions = [];
  const { selection } = product;

  const relatedVariants = product.variants.filter(({ combination }) => {
    const selectionValues = Object.values(selection.combination);
    const combinationValues = Object.values(combination);
    return combinationValues.some((value) => selectionValues.includes(value));
  });

  relatedVariants.forEach(({ combination }) => {
    const labels = Object.keys(combination);

    labels.forEach((label) => {
      const optionIndex = newAvailableOptions.findIndex((option) => option.label === label);
      const value = combination[label];

      if (optionIndex >= 0) {
        const newValues = [...newAvailableOptions[optionIndex].values, value];
        newAvailableOptions[optionIndex].values = [...new Set(newValues)];
      } else {
        newAvailableOptions.push({
          values: [value],
          label,
        });
      }
    });
  });

  return newAvailableOptions;
};

export const getSelectionData = (product) => {
  const { stock_option, stock_quantity, selection, variants } = product;

  const selectionData = {
    quantity: stock_quantity,
    variant_key: null,
    combination: {},
  };

  if (stock_option === 'varying_stock' || (stock_option === 'flat_stock' && variants.length)) {
    //  Filter out empty fields from selection object before comparison
    const selectedCombination = omitBy(selection.combination, isEmpty);
    if (isEmpty(selectedCombination)) selectionData.quantity = 0;

    const selectedVariant = variants.find(({ combination }) => isEqual(combination, selectedCombination));
    if (selectedVariant) {
      selectionData.combination = selectedVariant.combination;
      selectionData.variant_key = Number(selectedVariant.id);
      selectionData.quantity = selectedVariant.quantity;
    } else selectionData.quantity = 0;
  }

  const parsedQuantity = parsedInteger(selectionData.quantity);
  if (parsedQuantity === undefined) selectionData.quantity = 0;

  return selectionData;
};

export const selectionInfo = (product) => {
  const { selection, variants } = product;

  const isEmptySelection = isEmpty(omitBy(selection.combination, isEmpty));
  const selectedCombination = omitBy(selection.combination, isEmpty);

  const isFound = variants.some(({ combination }) => isEqual(combination, selectedCombination));

  return {
    isUnavailable: !isEmptySelection && !isFound,
    isSelected: !isEmptySelection,
  };
};

export const appendSelectionProps = (products, ctrlValue) => {
  const newProducts = toFrontEndShape(cloneDeep(products));

  return newProducts.map((product) => {
    let newProduct = { ...product, selection: { combination: {}, quantity: 0 } };

    product.options.forEach(({ label }) => {
      if (label) newProduct.selection.combination[label] = '';
    });

    if (ctrlValue?.products?.length) {
      const productInValue = ctrlValue.products.find(({ id }) => id === product.id);
      if (productInValue) newProduct = toFrontEndShape([productInValue])[0];
    }

    return newProduct;
  });
};

export const stockInfo = (product) => {
  const { stock_option, stock_quantity, variants } = product;
  
  const isNoVariantsInStock = variants.every(({ quantity }) => {
    const parsedQuantity = parsedInteger(quantity);
    return parsedQuantity === 0 || parsedQuantity === undefined;
  });

  const flatStockAvailability = () => {
    if (variants.length) return isNoVariantsInStock;
    const quantity = parsedInteger(stock_quantity);
    return quantity === 0 || quantity === undefined;
  };

  const stockAvailability = {
    flat_stock: flatStockAvailability(),
    varying_stock: isNoVariantsInStock,
  };
  
  return stockAvailability[stock_option];
};
